<template>
    <div @click="handleSelectInvitation(status)" :class="`dashboard__stats_box dashboard__stats_box--${status}`"
        :data-active="getSelectedInvitation.type === status">
        <h6>{{ text }}</h6>
        <br />
        <p>{{ statusCount }}</p>
    </div>
</template>


<script lang="js">

export default {
    props: {
        text: {
            type: String,
            required: true
        },
        statusCount: {
            type: Number,
            required: true
        },
        status: {
            type: String,
            required: true,
            validator: (status) => {
                return ["created", "approved", "denied", "cancelled", "expired", "pending"].includes(status)
            }
        }
    },
    methods: {
        async handleSelectInvitation(type) {

            // Unselect current type
            if (this.getSelectedInvitation.type === type) {
                this.setInvitationDetailType("")
                this.setInvitationDetailData(null)
                return
            }

            const params = {
                type,
                location_id: this.getLocation || null,
                start_date: this.getStartDate || null,
                end_date: this.getEndDate || null
            }

            // Track selected type 
            this.setInvitationDetailType(type)

            await this.fetchInvitationDetails(params);

        }
    }
}

</script>